import { CandidateExtracadabraExperienceModel, ICandidateExperience, IEtabCategory, IQualification } from "@core/models";

export const extracadabraExperience1 = {
  [ICandidateExperience.id]: 546,
  [ICandidateExperience.etabName]: "Buffalo Grill",
  [ICandidateExperience.etabCategory]: { [IEtabCategory.id]: 39, [IEtabCategory.name]: "Hôtel *****" },
  [ICandidateExperience.postalCode]: "91170",
  [ICandidateExperience.city]: "Viry Châtillon",
  [ICandidateExperience.contract]: "cdi",
  [ICandidateExperience.isCurrentPosition]: false,
  [ICandidateExperience.startDate]: "2022-08-01T00:00:00+00:00",
  [ICandidateExperience.endDate]: "2022-11-21T00:00:00+00:00",
  [ICandidateExperience.qualification]: { [IQualification.qualificationId]: 2, [IQualification.qualificationLabel]: "Serveur" },
  [ICandidateExperience.rating]: 3,
};

export const extracadabraExperience2 = {
  [ICandidateExperience.id]: 3243,
  [ICandidateExperience.etabName]: "Epheméra",
  [ICandidateExperience.postalCode]: "75013",
  [ICandidateExperience.etabCategory]: { [IEtabCategory.id]: 39, [IEtabCategory.name]: "Hôtel *****" },
  [ICandidateExperience.city]: "Paris",
  [ICandidateExperience.contract]: "cdi",
  [ICandidateExperience.isCurrentPosition]: false,
  [ICandidateExperience.startDate]: "2022-03-01T00:00:00+00:00",
  [ICandidateExperience.endDate]: "2022-08-21T00:00:00+00:00",
  [ICandidateExperience.qualification]: { [IQualification.qualificationId]: 84, [IQualification.qualificationLabel]: "Agent administratif\t" },
  [ICandidateExperience.rating]: 4,
};

export const extracadabraExperience3 = {
  [ICandidateExperience.id]: 975,
  [ICandidateExperience.etabName]: "O'tacos",
  [ICandidateExperience.etabCategory]: { [IEtabCategory.id]: 39, [IEtabCategory.name]: "Hôtel *****" },
  [ICandidateExperience.postalCode]: "91170",
  [ICandidateExperience.city]: "Viry Châtillon",
  [ICandidateExperience.contract]: "cdi",
  [ICandidateExperience.isCurrentPosition]: false,
  [ICandidateExperience.startDate]: "2021-08-01T00:00:00+00:00",
  [ICandidateExperience.endDate]: "2022-11-21T00:00:00+00:00",
  [ICandidateExperience.qualification]: { [IQualification.qualificationId]: 2, [IQualification.qualificationLabel]: "Serveur" },
  [ICandidateExperience.rating]: 2,
};

export const extracadabraExperience4 = {
  [ICandidateExperience.id]: 456,
  [ICandidateExperience.etabName]: "Hipoppotamus",
  [ICandidateExperience.postalCode]: "91170",
  [ICandidateExperience.city]: "Viry Châtillon",
  [ICandidateExperience.etabCategory]: { [IEtabCategory.id]: 39, [IEtabCategory.name]: "Hôtel *****" },
  [ICandidateExperience.contract]: "cdi",
  [ICandidateExperience.isCurrentPosition]: false,
  [ICandidateExperience.startDate]: "2010-08-01T00:00:00+00:00",
  [ICandidateExperience.endDate]: "2011-11-21T00:00:00+00:00",
  [ICandidateExperience.qualification]: { [IQualification.qualificationId]: 2, [IQualification.qualificationLabel]: "Serveur" },
  [ICandidateExperience.rating]: 1,
};

export const candidateExtracadabraExperiencesMocks = [
  extracadabraExperience1,
  extracadabraExperience2,
  extracadabraExperience3,
  extracadabraExperience4,
].map((experience) => new CandidateExtracadabraExperienceModel(experience));
